import { ROUTES } from 'constants/routes';

export const PUBLIC_NAVIGATION = [
  {
    name: 'Search PDF',
    link: ROUTES.search_pdf,
  },
  {
    name: 'Authorized Partners',
    link: ROUTES.authorized_partners,
  },
  {
    name: 'About us',
    link: ROUTES.about,
  },
];

export const PRIVATE_NAVIGATION = [
  {
    name: 'Create PDF',
    link: ROUTES.create_authorized,
    forUserType: 'service station',
  },
  {
    name: 'Calibration History',
    link: ROUTES.pdf_history,
    forUserType: 'service station',
  },
  {
    name: 'Registration History',
    link: ROUTES.registration_history,
    forUserType: 'service station',
  },
  {
    name: 'Fleet List',
    link: ROUTES.fleet_list,
    forUserType: 'shipping company',
  },
  {
    name: 'Registration History',
    link: ROUTES.registration_history_shipping,
    forUserType: 'shipping company',
  },
];
